import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
`;

export const Title = styled.h4`
  padding: 0;
  margin: 0;
`;

export const Content = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
`;

export const ConfigButton = styled.div`
  background: transparent;
  border: none;
  transform: rotate(75deg);
  opacity: 0;
  transition: opacity ease-in-out 0.5s;
  font-size: 20px;
  width: 30px;
  padding: 2px;

  &:after {
    content: '✎'
  }

  ${Wrapper}:hover & {
    opacity: 1;
  }
`;


// WEBPACK FOOTER //
// ./src/components/Panel/Panel.style.js